import React, { useState, useEffect } from "react";
import _ from "lodash";
import MenuIcon from "@mui/icons-material/Menu";

import Box from "@mui/material/Box";
import IconLogoCRM from "@metacrm/metacrm-svg/dist/SvgIcon/svg-icons/IconLogoCRM";
import {
  StyledTextHeader,
  StyledSettingIcon,
  StyledCard,
  StyledDemoTemplateBody,
  StyledDemoTemplateInfoArea,
  StyledTicketList,
  StyledTicketItem,
  StyledTicketItemStatus,
  StyledDemoTemplateChatArea,
  StyledDemoTemplateChatAreaHeaderContainer,
  StyledAdminMessageItemMsg,
  StyledAdminMessageItemMsgTitle,
  StyledBottomNavigation,
  StyledBottomNavigationContentContainer,
  StyledBottomNavigationIcon,
  StyledFixBottomContainer,
  StyledFixBottomText,
  StyledMsgItem,
  StyledMsgItemContainer,
  StyledTimeStamp,
  StyledAdminInfo,
} from "./WidgetDemoTemplate.styles";
import { getShortAddress } from "features/helpers/utils";
import { useIntl } from "react-intl";
import { useTheme } from "@mui/styles";
import { alpha } from "@mui/material/styles";

const black = "#222";
const white = "#fff";
const white87 = alpha(white, 0.87);
const white60 = alpha(white, 0.6);
const white38 = alpha(white, 0.38);
const white7 = alpha(white, 0.07);

export const getBrightness = (rgb) => {
  if (!rgb) return;
  // 將hex顏色轉換為rgb
  const [r, g, b] = _.map(rgb.match(/\w\w/g), (x) => parseInt(x, 16));
  // 計算亮度
  return (r * 299 + g * 587 + b * 114) / 1000;
};

export const textWithDynamicColor = (bgColor) => {
  // 計算背景顏色的亮度
  const brightness = getBrightness(bgColor);
  // 根據亮度選擇文字顏色
  return brightness > 128 ? black : "white";
};

const WidgetDemoTemplate = ({ colorArray, colorTheme, logoIcon }) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();

  const { mode, primaryColor } = colorTheme;

  const isLight = mode === "light";

  const mainColor = mode === "light" ? "#FFF" : "#121212";

  const convertColorArrayToObject = (array) => {
    let obj = {};
    for (let item of array) {
      obj[item.name] = item.color;
    }
    return obj;
  };

  const colorSetting = convertColorArrayToObject(colorArray);

  const {
    // primaryColor,
    hoverColor,
    backgroundColor,
    textHoverColor,
    cardColor,
    cardHoverColor,
  } = colorSetting;

  const widgetRoutes = [
    {
      name: "global.function.home",
      icon: <i className="meta-crm-icon-ic_home_outline font-size-24" />,
      isActive: true,
      unRead: false,
    },
    {
      name: "global.function.ticket",
      icon: <i className="meta-crm-icon-ic_file_outline font-size-24" />,
      isActive: false,
      unRead: false,
    },
    {
      name: "global.function.notifications",
      icon: (
        <i className="meta-crm-icon-ic_bell_regular_outline font-size-24" />
      ),
      isActive: false,
      unRead: true,
    },
  ];

  return (
    <div style={{ maxWidth: 700, margin: "0 auto" }}>
      <StyledDemoTemplateBody>
        <Box
          sx={{
            background: mainColor,
            marginRight: "24px",
            borderRadius: "7.5px 7.5px 0 0",
          }}
        >
          <StyledDemoTemplateInfoArea
            mainColor={mainColor}
            primaryColor={primaryColor}
            mode={mode}
          >
            <Box padding="20px 16px">
              <div className="betweenRow">
                {/* <IconLogoCRM height={32} width={32} /> */}
                {logoIcon}
                <StyledSettingIcon mode={mode} mainColor={mainColor}>
                  {/* <i className="meta-crm-icon-ic_settingLine font-size-24" /> */}
                  <Box
                    component="i"
                    className="meta-crm-icon-ic_wallet font-size-12"
                    mr={"5px"}
                  />
                  <Box sx={{ fontSize: "8px" }}>
                    {getShortAddress("000000000000000000000000000000000")}
                  </Box>
                </StyledSettingIcon>
              </div>
              <StyledTextHeader
                style={{ textAlign: "left" }}
                color={textWithDynamicColor(backgroundColor)}
              >
                <Box
                  color={
                    mode === "light" ? theme.customColors.grey[700] : white87
                  }
                  sx={{
                    fontSize: "15px",
                  }}
                >
                  Hello there,
                </Box>
                <Box
                  color={mode === "light" ? "#222" : "#FFF"}
                  sx={{ fontSize: "17.5px" }}
                >
                  How can we help ?
                </Box>
              </StyledTextHeader>
              <Box display={"flex"} justifyContent={"space-between"}></Box>
              <Box
                sx={{
                  boxShadow: "0px 1.25px 6.25px 0px #0000000D",
                  border: `1px solid ${isLight ? "#E6E6E6" : "transparent"}`,
                  borderRadius: "5px",
                  padding: "12.5px 15px",
                  backgroundColor: isLight ? white : white7,
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                  lineHeight: "normal",
                }}
              >
                <Box sx={{ maxWidth: "175px" }}>
                  <Box
                    sx={{
                      fontSize: "8.75px",
                      color: isLight ? black : white87,
                      marginBottom: "5px",
                    }}
                  >
                    Recent Message
                  </Box>
                  <Box
                    sx={{
                      fontSize: "8.75px",
                      color: isLight ? "#777" : white60,
                      marginBottom: "5px",
                    }}
                  >
                    But before I do that, could you give me your work email?
                  </Box>
                  <Box
                    sx={{
                      fontSize: "7.5px",
                      color: isLight ? "#A5A5A5" : white38,
                    }}
                  >
                    You・29 Mar 2023 23:24
                  </Box>
                </Box>
                <Box
                  sx={{
                    marginLeft: "auto",
                    color: isLight ? "#1D1D1D" : white87,
                  }}
                >
                  <i className="meta-crm-icon-ic_arrowLineRight font-size-12" />
                </Box>
              </Box>

              <Box
                sx={{
                  boxShadow: "0px 1.25px 6.25px 0px #0000000D",
                  backgroundColor: primaryColor,
                  borderRadius: "5px",
                  fontWeight: 700,
                  fontSize: "8.75px",
                  padding: "13.5px 15px",
                  color: textWithDynamicColor(primaryColor),
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Submit a Ticket
                <Box
                  component="i"
                  className="meta-crm-icon-ic_sendMessage font-size-12"
                  ml="auto"
                ></Box>
              </Box>
            </Box>
            {/* <StyledBottomNavigation>
            {widgetRoutes.map((route, index) => (
              <StyledBottomNavigationContentContainer
                color={route.isActive ? primaryColor : "#A5A5A5"}
                key={index}
                unRead={route.unRead}
              >
                <StyledBottomNavigationIcon unRead={route.unRead}>
                  {route.icon}
                </StyledBottomNavigationIcon>
                <Box>
                  {formatMessage({
                    id: route.name,
                  })}
                </Box>
              </StyledBottomNavigationContentContainer>
            ))}
          </StyledBottomNavigation> */}
          </StyledDemoTemplateInfoArea>
        </Box>

        <StyledDemoTemplateChatArea isLight={isLight}>
          <StyledDemoTemplateChatAreaHeaderContainer
            primaryColor={isLight ? primaryColor : "#2E2E2E"}
          >
            <Box
              color={
                mode === "light" ? textWithDynamicColor(primaryColor) : "white"
              }
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box
                display={"flex"}
                alignItems={"center"}
                sx={{ position: "absolute" }}
                left={"10px"}
              >
                <i className="meta-crm-icon-ic_arrowLineLeft font-size-16" />
              </Box>
              <Box sx={{ margin: "0 auto" }}>Message</Box>
            </Box>
          </StyledDemoTemplateChatAreaHeaderContainer>
          <Box>
            <StyledMsgItemContainer>
              <StyledMsgItem primaryColor={primaryColor} isLight={isLight}>
                Hi
              </StyledMsgItem>
              <StyledTimeStamp isLight={isLight}>
                22 Oct 2024, 10:17
              </StyledTimeStamp>
            </StyledMsgItemContainer>

            <StyledMsgItemContainer isAdmin>
              <StyledAdminInfo>
                <Box
                  component="img"
                  src={require("assets/img/preview_admin_avatar.png")}
                  width="15px"
                  height="15px"
                  marginRight="3px"
                ></Box>

                <Box
                  sx={{
                    fontSize: "7.5px",
                    color: isLight ? theme.customColors.grey[600] : white87,
                  }}
                >
                  Agent
                </Box>
              </StyledAdminInfo>
              <StyledMsgItem
                primaryColor={primaryColor}
                isLight={isLight}
                isAdmin
              >
                Hello, how can I help you?
              </StyledMsgItem>
              <StyledTimeStamp isAdmin isLight={isLight}>
                22 Oct 2024, 10:18
              </StyledTimeStamp>
            </StyledMsgItemContainer>

            <StyledMsgItemContainer>
              <StyledMsgItem primaryColor={primaryColor} isLight={isLight}>
                I have issue with my form. I got feedback that when surveys
                enter to question Ａ, they cannot see options!
              </StyledMsgItem>
              <StyledTimeStamp isLight={isLight}>
                22 Oct 2024, 10:19
              </StyledTimeStamp>
            </StyledMsgItemContainer>

            <StyledMsgItemContainer isAdmin>
              <StyledAdminInfo>
                <Box
                  component="img"
                  src={require("assets/img/preview_admin_avatar.png")}
                  width="15px"
                  height="15px"
                  marginRight="3px"
                ></Box>

                <Box
                  sx={{
                    fontSize: "7.5px",
                    color: isLight ? theme.customColors.grey[600] : white87,
                  }}
                >
                  Agent
                </Box>
              </StyledAdminInfo>
              <StyledMsgItem
                primaryColor={primaryColor}
                isLight={isLight}
                isAdmin
              >
                Please fill in the title.
              </StyledMsgItem>
              <StyledTimeStamp isAdmin isLight={isLight}>
                22 Oct 2024, 10:20
              </StyledTimeStamp>
            </StyledMsgItemContainer>
          </Box>
        </StyledDemoTemplateChatArea>
      </StyledDemoTemplateBody>
    </div>
  );
};

export default WidgetDemoTemplate;
